import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { environment } from "../../environments/environment";
import { AuthenticationService } from "../services/authentication.service";

@Injectable({
  providedIn: "root",
})
export class SuperadminGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;
    if (currentUser && currentUser.rules == "admin" && !currentUser.iscustomer) {
      // logged in so return true
      return true;
    }
    console.log('====================================');
    console.log(currentUser);
    console.log('====================================');
    // not logged in so redirect to login page with the return url
    this.router.navigate(["/ups"], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
